import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {NewsPage, User} from '../../../shared/models';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {CmsService} from '../../../shared/services/cms.service';
import {takeUntil} from 'rxjs/operators';
import {AuthService} from '../../../shared/modules/auth/auth.service';
import {environment} from '../../../../environments/environment';
import {SeoUtil} from '../../../shared/utils';
import {FilePipe} from '../../../shared/pipes/file/file.pipe';

@Component({
  selector: 'app-news-page',
  templateUrl: './news-page.component.html'
})
export class NewsPageComponent implements OnInit, OnDestroy {
  public SITE_URL: string = environment.sites.root;

  user: User;
  newsPage: NewsPage;

  private destroy$ = new Subject();

  constructor(@Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2,
              private router: Router,
              private route: ActivatedRoute,
              private cmsService: CmsService,
              private authService: AuthService,
              private filePipe: FilePipe,
              private seoUtil: SeoUtil) {
  }

  ngOnInit(): void {
    this.renderer.addClass(this.document.body, 'p-newsArticle');
    this.handleRouteChange();
    this.handleUserChange();
  }

  ngOnDestroy() {
    this.renderer.removeClass(this.document.body, 'p-newsArticle');
    this.seoUtil.setDefaultMetaTags();
    this.seoUtil.setDefaultTitle();
    this.destroy$.next();
    this.destroy$.complete();
  }

  getSize(columns: number): number {
    return (columns > 0 && columns < 4 ? columns / 4 * 12 : 12);
  }

  encodeSiteUrl(uri): string {
    return encodeURIComponent(uri);
  }

  private fetchNewsPage(id: string): void {
    this.newsPage = null;
    this.cmsService.getPage(id).subscribe(page => {
      this.newsPage = page;
      this.seoUtil.updateTitle(page.title, false);
      this.seoUtil.updateMetaTags([
        {property: 'og:title', content: page.title},
        {property: 'og:description', content: page.description},
        {property: 'og:image', content: this.filePipe.transform(page.mainImage || page.secondaryImage, 'image', 'cms', 1280)},
        {property: 'og:url', content: this.SITE_URL + page.category.urlSlug + '/' + page.urlSlug}
      ]);
    }, () => {
      this.router.navigate(['/not-found'], {skipLocationChange: true}).finally();
    });
  }

  private handleRouteChange(): void {
    this.route.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        let id = params['id'];
        if (id) {
          this.fetchNewsPage(id);
        }
      });
  }

  private handleUserChange() {
    if (this.authService.isLoggedIn()) {
      this.authService.getAuthUser().subscribe(user => {
        this.user = user;
      });
    } else {
      this.user = null;
    }
    this.authService.userChanged()
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.user = user;
      });
  }

}
